/**
 * TanStack Query mutation retry helper. Avoids retrying writes when the server
 * already handled the request and returned a client error (e.g. 400 after an
 * order row was created for "Area not serviced").
 */
export function shouldRetryFailedMutation(failureCount: number, error: unknown): boolean {
  if (failureCount >= 1) return false;
  const status = getAxiosLikeErrorStatus(error);
  if (status !== undefined && status >= 400 && status < 500) return false;
  return true;
}

function getAxiosLikeErrorStatus(error: unknown): number | undefined {
  if (!error || typeof error !== "object" || !("response" in error)) return undefined;
  const response = (error as { response?: unknown }).response;
  if (!response || typeof response !== "object" || !("status" in response)) return undefined;
  const status = (response as { status?: unknown }).status;
  return typeof status === "number" ? status : undefined;
}
